export default "__VITE_ASSET__B0uz1$Oh__"